import { RouteObject } from "react-router-dom";
import HomePage from "@/pages/home/page";
import AboutPage from "@/pages/about/page";
import ConsultationPage from "@/pages/consultation/page";
import MinistryPage from "@/pages/ministry/page";
import StorePage from "@/pages/store/page";
import ContactPage from "@/pages/contact/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  { path: "/", element: <HomePage /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/consultation", element: <ConsultationPage /> },
  { path: "/ministry", element: <MinistryPage /> },
  { path: "/store", element: <StorePage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
